import {
  UPDATE_CATEGORY_CLAIM_DATA,
  UPDATE_DESC_OF_DAMAGE_CHECK_BOX,
  UPDATE_DESC_DAMAGE_VALUE,
} from "../actions"

// Develop note
// Now the initial state is left in pristine conditions and the resulting state is just a copy of the initial state. Remember two key points for avoiding mutations in Redux:
// --use concat(), slice(), or the spread operator for arrays
// --use Object.assign() or object spread of objects

const initialClaimData = {
  claimInfo: {
    claimAttributeModel: {
      riskType: "",
      riskNo: "",
      productType: "",
      policyStartDate: "",
      policyEndDate: "",
      upStatus: "",
    },

    policyInfo: {
      workshop: "",
      otherWorkshopName: "",
      otherWorkshopAddress: "",
      otherWorkshopContactNo: "",
      workshopContactPerson: "",
      workshopEmail: "",

      policyNumber: "",
      policyNumberOfMasterAccount: "",
      masterAccountNumber: "",
      vehicleNumber: "",

      policyHolderName: "",
      claimantNricNumber: "",
      claimantEmail: "",
      claimantMobile: "",

      driverName: "",
      driverIC: "",
      driverAddress: "",
      driverOccupation: "",
      otherDriverOccupation: "",
      driverMobileNo: "",
      driverResidentialTelNo: "",
      driverBusinessTelNo: "",
      authorisationToDrive: true,

      accidentDate: "",
      accidentTime: "",
      accidentLocation: "",

      natureOfDamage:
        "Shattered or Broken / Cracked hit by stone while driving",
      otherNatureOfDamage: "",

      claimAmount: "",
      sourceSystem: "Web",
      declaration: 0,

      // workshop: "Others",
      // otherWorkshopName: "abc pte ltd",
      // otherWorkshopAddress: "No. 22-01",
      // otherWorkshopContactNo: "98063015",
      // workshopContactPerson: "AH LI",
      // workshopEmail: "XieBin.W@devops.etiqa.com.sg",

      // policyNumber: "MB002478",
      // vehicleNumber: "S123A",

      // policyHolderName: "Davy",
      // claimantNricNumber: "S1234567A",
      // claimantEmail: "XieBin.W@devops.etiqa.com.sg",
      // claimantMobile: "98063015",

      // driverName: "AH MENG",
      // driverIC: "S1234567A",
      // driverAddress: "No 22-01",
      // driverOccupation: "Author",
      // otherDriverOccupation: "",
      // driverMobileNo: "98063015",
      // driverResidentialTelNo: "",
      // driverBusinessTelNo: "",
      // authorisationToDrive: true,

      // accidentDate: "",
      // accidentTime: "00:12",
      // accidentLocation: "Location",

      // natureOfDamage:
      //   "Shattered or Broken / Cracked hit by stone while driving",
      // otherNatureOfDamage: "",

      // claimAmount: "123",
      // sourceSystem: "Web",
      // declaration: 0,
    },
    claimWindscreenItems: [],
  },
}

const claimDataReducer = (state = initialClaimData, action) => {
  const category = action.category
  const coverageCode = action.coverageCode
  const name = action.name
  const newState = Object.assign({}, state)

  switch (action.type) {
    case UPDATE_CATEGORY_CLAIM_DATA:
      newState[category][coverageCode][name] = action.value
      return Object.assign({}, state, newState)

    case UPDATE_DESC_OF_DAMAGE_CHECK_BOX:
      if (
        newState.claimInfo.claimWindscreenItems.filter(
          x => x.damageItem === action.textDesc
        ).length <= 0
      ) {
        newState.claimInfo.claimWindscreenItems.push({
          damageItem: action.textDesc,
          damageDesc: "Repair",
        })
      } else {
        let index = newState.claimInfo.claimWindscreenItems.findIndex(
          x => x.damageItem === action.textDesc
        )
        newState.claimInfo.claimWindscreenItems.splice(index, 1)
      }
      return Object.assign({}, state, newState)

    case UPDATE_DESC_DAMAGE_VALUE:
      let index = newState.claimInfo.claimWindscreenItems.findIndex(
        x => x.damageItem === action.textDesc
      )
      newState.claimInfo.claimWindscreenItems[index].damageDesc =
        action.buttonValue
      return Object.assign({}, state, newState)

    default:
      return Object.assign({}, state, newState)
  }
}
export default claimDataReducer
